import { fetchGet } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const apiFetchTopics = async (phone) => {
  const suggestedApiUrl = await getParam('suggestedContentApiUrl')

  return fetchGet(`${suggestedApiUrl}/swimlane`, { phone, count: 10 })
}
